export enum MainLineImageType {
  BEGINNING = 1,
  GUIDE,
  ENDING,
  STAGE_BEGINNING,
}

export enum STAGE_ANIMATE_TYPE {
  STAGE_BEGINNING = 1,
  STAGE_ENDING,
}

export enum RESULT {
  NO, // 未完成
  YES,
}

export enum MAINLINE_TYPE_ENUM {
  MAINLINE_START = 'MAINLINE_START', // 主线开始动画：
  MAINLINE_GUIDE = 'MAINLINE_GUIDE', // 主线引导动画：
  MAINLINE_FINISH = 'MAINLINE_FINISH', // 主线完成动画：
  STAGE_RECEIVE = 'STAGE_RECEIVE', // 章节开始标识(新增事件)：
  STAGE_START = 'STAGE_START', // 章节开始动画：
  STAGE_FINISH = 'STAGE_FINISH', // 章节完成弹窗：
  MISSION_FINISH = 'MISSION_FINISH', // 任务完成弹窗：
}

export const formatMainlineData = (mainlineList: any[] = []) => {
  return {
    beginningList: mainlineList.filter((v) => v.type === MainLineImageType.BEGINNING) || [],
    guideList: mainlineList.filter((v) => v.type === MainLineImageType.GUIDE) || [],
    endingList: mainlineList.filter((v) => v.type === MainLineImageType.ENDING) || [],
  };
};

export const formatStageData = (stageImageList: any[] = []) => {
  return {
    stageBeginningList:
      stageImageList.filter((v) => v.type === STAGE_ANIMATE_TYPE.STAGE_BEGINNING) || [],
    stageEndingList: stageImageList.filter((v) => v.type === STAGE_ANIMATE_TYPE.STAGE_ENDING) || [],
  };
};

export const isPAG = (url: string) => url?.split('.')?.reverse()?.[0] === 'pag';

export const html_encode = function (str: string) {
  let s = '';
  if (str != undefined) {
    if (str.length == 0) {
      return '';
    }
    s = str;
    // s = s.replace(/&/g, '&gt;');
    // s = s.replace(/</g, '&lt;');
    // s = s.replace(/>/g, '&gt;');
    s = s.replace(/ /g, '&nbsp;');
    s = s.replace(/\'/g, '&#39;');
    s = s.replace(/\"/g, '&quot;');
    s = s.replace(/\n/g, '<br/>');
  }
  return s;
};
